// extracted by mini-css-extract-plugin
export default {"dataGrid":"LogsTableLine_dataGrid__JUenn","tileTitle":"LogsTableLine_tileTitle__w3eju"};